import * as React from 'react';
import {useState, useContext, useEffect} from 'react';
import ToggleBtnTheme from '../../components/ToggleBtnTheme/index';
import LogoWhite from '../../assets/images/logo_white.png';
import {Menu} from '@mui/material'; // USAR QUANDO FECHAR A SIDEBAR
import TranslateIcon from '@mui/icons-material/Translate';
import i18n from '../../i18n';
import {useTranslation} from 'react-i18next';
import {SidebarData} from '../Sidebar/SidebarData';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import {useLocation} from 'react-router-dom';
import {Context} from '../../Helpers/Auth';
import {useHistory} from 'react-router-dom';
import AlterarIdiomaModal from '../AlterarIdiomaModal';
import ShoppingCartRoundedIcon from '@mui/icons-material/ShoppingCartRounded';

export default function Navbar() {
    const history = useHistory();
    const {t} = useTranslation();
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const location = useLocation();
    const [openModal, setOpenModal] = useState(false);

    // function alterarIdioma() {
    //   const selected = localStorage.getItem("i18nextLng");
    //   if (selected == "pt") {
    //     i18n.changeLanguage("fr");
    //     localStorage.setItem("i18nextLng", "fr");
    //   } else if (selected == "fr") {
    //     i18n.changeLanguage("en");
    //     localStorage.setItem("i18nextLng", "en");
    //   } else if (selected == "en") {
    //     i18n.changeLanguage("pt");
    //     localStorage.setItem("i18nextLng", "pt");
    //   }
    // }

    const {utilizador, oficina, handleOficina, nome, handleLogout} = useContext(Context);

    const handleLogoutClick = () => {
        localStorage.removeItem('token');
        handleLogout();
        history.push('/autenticacao');
    };

    return (
        <>
            <div className="flex  z-40">
                <div className="fixed w-full flex items-center justify-between text-white ">
                    <div className="flex  items-center cursor-pointer justify-start md:justify-start pl-3 w-14 md:w-64 h-8 bg-blue-800 dark:bg-gray-800 border-none">
                        <a href="/Dashboard">{/* <img className="p-6 md:w-10 md:h-10 mr-2 overflow-hidden cursor-pointer" width={'80%'} className="p-8" src={LogoWhite} /> */}</a>
                    </div>
                    <div className="flex w-full justify-end items-center h-8 bg-blue-800 dark:bg-gray-800 header-right">
                        <ul className="flex items-center">
                            <li>
                                <span className="flex items-center font-medium mr-4 hover:text-blue-100">{nome}</span>
                            </li>

                            <li>
                                <button
                                    aria-hidden="true"
                                    className="group p-1 transition-colors duration-200 rounded-full shadow-md bg-blue-200 hover:bg-blue-300 dark:bg-gray-500 dark:hover:bg-gray-600 text-gray-900 focus:outline-none">
                                    <ToggleBtnTheme className="w-2" />
                                </button>
                            </li>
                            {/* <li>
                                <button
                                    aria-hidden="true"
                                    className="group p-1 ml-3 transition-colors duration-200 rounded-full shadow-md  hover:bg-blue-600  dark:hover:bg-gray-600 text-white focus:outline-none">
                                    <ShoppingCartRoundedIcon className="w-2" />
                                </button>
                            </li> */}
                            <li>
                                <div className="block w-px h-6 mx-3 bg-gray-400 dark:bg-gray-700"></div>
                            </li>
                            <li>
                                <a href="#" className="flex items-center mr-4 hover:text-blue-100" onClick={handleLogoutClick}>
                                    <span className="inline-flex mr-1">
                                        <LogoutOutlinedIcon />
                                    </span>
                                    {t('terminarSessao')}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* <div className="flex flex-row justify-center mt-1/2 ml-14 ">aqui</div> */}
                <div className="fixed flex flex-col top-8 left-0 w-14  hover:w-48 md:w-48 bg-blue-900 dark:bg-gray-900 h-full text-white transition-all duration-300 border-none  sidebar">
                    <div className="overflow-y-auto overflow-x-hidden flex flex-col justify-between flex-grow">
                        <ul className="flex flex-col py-4 space-y-1">
                            <li className="px-5 hidden md:block">
                                <div className="flex flex-row items-center h-8">
                                    <div className="text-sm font-light tracking-wide text-gray-400 uppercase">{t('menu')}</div>
                                </div>
                            </li>
                            {SidebarData.map((item, index) => (
                                <>
                                    <li>
                                        <a
                                            // href={item.path}
                                            onClick={() => {
                                                setSelectedItem(index);
                                                history.push(item.path);
                                            }}
                                            // className={"relative flex flex-row items-center h-11 focus:outline-none  text-white-600 hover:text-white-800 border-l-4 border-transparent pr-6  hover:bg-blue-800 dark:hover:bg-gray-600 hover:border-blue-500 dark:hover:border-gray-800 "}
                                            className={`cursor-pointer relative flex flex-row text-xs items-center h-11 focus:outline-none  text-white-600 hover:text-white-800 border-l-4 border-transparent pr-6 ${
                                                item.path === location.pathname && 'bg-blue-800 dark:bg-gray-600 text-white-800 border-blue-500 dark:border-blue-800'
                                            }`}>
                                            <span className="inline-flex  justify-center items-center ml-4">{item.icon}</span>
                                            <span className="ml-2 text-sm tracking-wide truncate">{t(item.title)}</span>
                                        </a>
                                    </li>
                                </>
                            ))}
                            {/* </ul> */}

                            {/* <ul className="flex flex-col py-4 space-y-1"> */}
                            <li className="px-5 hidden md:block">
                                <div className="flex flex-row items-center mt-5 h-8">
                                    <div className="text-sm font-light tracking-wide text-gray-400 uppercase">{t('config')}</div>
                                </div>
                            </li>
                            <li>
                                <a
                                    href="#"
                                    className="relative flex text-xs flex-row items-center h-11 focus:outline-none hover:bg-blue-800 dark:hover:bg-gray-600 text-white-600 hover:text-white-800 border-l-4 border-transparent hover:border-blue-500 dark:hover:border-gray-800 pr-6">
                                    <span className="inline-flex justify-center items-center ml-4">
                                        <TranslateIcon />
                                    </span>
                                    <span className="ml-2 text-sm tracking-wide truncate" onClick={() => setOpenModal(true)}>
                                        {t('alterarIdioma')}
                                    </span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                {openModal && <AlterarIdiomaModal cancelar={() => setOpenModal(false)} />}
            </div>
        </>
    );
}
